import React, { Component } from "react";
import { connect } from "react-redux";
import CustomerList from "./customerList";
import CreateCustomerData from "./createCustomer";
import Button from "@mui/material/Button";
import "../../assets/css/settings.css";
import { fetchCustomers } from "../../api/customer";
import {
  fetchCustomersRequest,
  fetchCustomersSuccess,
  fetchCustomersFailure,
} from "../../actions/customer";
import Grid from "@mui/material/Grid";
import { TextField } from "@mui/material";
import "../../assets/css/customer.css";

import { fetchCompanies } from "../../api/company";
import { fetchDeliveryMethod } from "../../api/deliveryMethod";
import CompanyContext from "../../helpers/CompanyContext"; 

class CustomerPage extends Component {
  static contextType = CompanyContext; 

  constructor(props) {
    super(props);
    this.state = {
      isPopupOpen: false,
      isCustomerDetailsOpen: false,
      companies: [],
      deliveryMethods: [],
      searchText: "",
      selectedCustomer: null,
      previousCompanyId: null, // Track previous company to detect changes
    };
  }

  // Extract data fetching into reusable method
  fetchData = () => {
    this.props.fetchCustomersRequest();
    fetchCustomers()
      .then((data) => {
        console.log("customers fetched:", data);
        this.props.fetchCustomersSuccess(data);
      })
      .catch((error) => this.props.fetchCustomersFailure(error));

    fetchCompanies()
      .then((data) => {
        console.log("companies:", data);
        this.setState({ companies: data });
      })
      .catch((error) => {
        console.error("Error fetching company detail: ", error);
      });

    fetchDeliveryMethod()
      .then((data) => {
        console.log("delivery methods:", data);
        this.setState({ deliveryMethods: data });
      })
      .catch((error) => {
        console.error("Error fetching delivery methods: ", error);
      });
  };

  componentDidMount() {
    this.fetchData();
    
    // Store initial company ID
    const { selectedCompany } = this.context;
    this.setState({ previousCompanyId: selectedCompany });
  }

  // Check for company changes
  componentDidUpdate(prevProps, prevState) {
    const { selectedCompany } = this.context;
    
    // If company changed, refetch data
    if (selectedCompany !== this.state.previousCompanyId) {
      console.log("🔄 Company changed in Customer page, refetching data...");
      this.setState({ 
        previousCompanyId: selectedCompany,
        searchText: "", // Reset search
        isPopupOpen: false, // Close any open popups
        isCustomerDetailsOpen: false,
        selectedCustomer: null,
      });
      this.fetchData();
    }
  }

  handleOpenPopup = () => {
    this.setState({
      isPopupOpen: true,
      searchText: "",
      isCustomerDetailsOpen: false,
    });
  };

  handleClosePopup = () => {
    this.setState({ isPopupOpen: false });
  };

  handleSelectedCustomer = (selectedCustomer) => {
    this.setState({
      selectedCustomer,
      isPopupOpen: false,
      isCustomerDetailsOpen: true,
    });
  };

  handleCloseSelectedCustomer = () => {
    this.setState({
      isCustomerDetailsOpen: false,
    });
  };

  handleSearchChange = (event) => {
    this.setState({ searchText: event.target.value.toLowerCase() });
  };

  render() {
    const { searchText, selectedCustomer, companies, deliveryMethods } =
      this.state;
    const { customers } = this.props;
    return (
      <div className="customer-page">
        <h4 className="text-center text-acumen-color">Customers</h4>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={3}
            style={{ marginBottom: "true", padding: "16px" }}>
            {this.state.isPopupOpen && (
              <CreateCustomerData
                handleClose={this.handleClosePopup}
                companies={companies}
                deliveryMethods={deliveryMethods}
              />
            )}
            <TextField
              id="outlined-search"
              label="Search Customers"
              type="search"
              value={this.state.searchText}
              onChange={this.handleSearchChange}
              style={{ margin: "0px", padding: "0" }}
            />
          </Grid>
          {/* Added: Add Customer button next to the search field, calls the
              existing handleOpenPopup to mount CreateCustomerData in create mode */}
          <Grid
            item
            xs={12}
            sm={9}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "16px",
            }}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleOpenPopup}>
              Add Customer
            </Button>
          </Grid>
        </Grid>
        <br />
        <br /> <br />
        <br />
        <Grid item xs={12} sm={4}>
          <CustomerList
            customers={customers}
            searchText={searchText}
            companies={companies}
            deliveryMethods={deliveryMethods}
            onCustomerSelect={this.handleSelectedCustomer}
          />
          {this.state.isCustomerDetailsOpen && selectedCustomer ? (
            <CreateCustomerData
              handleClose={this.handleCloseSelectedCustomer}
              companies={companies}
              deliveryMethods={deliveryMethods}
              customerId={selectedCustomer.id}
            />
          ) : (
            <></>
          )}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customers: state.customers,
  };
};

const mapDispatchToProps = {
  fetchCustomersRequest,
  fetchCustomersSuccess,
  fetchCustomersFailure,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerPage);